import { Component } from "react";
import moment from "moment";
import Select from "../components/Select";
import { BsCheckLg } from "react-icons/bs";
import { IoIosArrowForward } from "react-icons/io";
import { IoIosArrowDown } from "react-icons/io";
import { MdAutorenew } from "react-icons/md";

import search_button from "./resources/search_button.png";
import enquiry_button from "./resources/enquiry_button.png";
import creditCardIcon from "../balance/mobile/transactions/resources/creditCard.png";
import bankIcon from "../balance/mobile/transactions/resources/bank.png";
import CommentButton from "../components/TransactionComments/CommentButton";
import Api from "../utils/Api";

class MobileTransactionItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            id: props.item.id,
            time: moment(props.item.time).format("DD-MM-YY"),
            description: props.item.description,
            remarks: props.item.remarks,
            categoryId: props.item.categoryId,
            amount: props.item.amount,
            totalAmount: props.item.totalAmount,
            isCredit: props.item.isCredit,
            type: props.item.type,
            creditCard: props.item.creditCard,
            accountNumber: props.item.accountNumber,
            predictionGrade: props.item.predictionGrade,
            tags: props.item.tags,
            expanded: false,
            categoryLookup: props.categoryLookup,
            tagLookup: props.tagLookup,
            approvalMode: props.approvalMode,
            editLabel: "ערוך",
            editMode: false,
            showSaveError: props.showSaveError,
            showSaveSuccess: props.showSaveSuccess,
            removeTransactionCallback: props.removeTransactionCallback,
            reccuringData: props.item.reccuringData,
            saveInProcess: false
        };

        this.state.categoryDescription = this.getCategoryDescription(props.item.categoryId);
        
        // Long press handling
        this.longPressTimer = null;
        this.touchStartPos = null;
    }

    getCategoryDescription(categoryId) {
        const match = this.state.categoryLookup.find(function (item) {
            return item.id === categoryId;
        });

        if (match) {
            return match.description;
        } else {
            return "קטגוריה חסרה";
        }
    }

    async handleSaveClick() {
        this.setState({ saveInProcess: true });
        const updateItem = {
            id: this.state.id,
            type: this.state.type,
            remarks: this.state.remarks,
            categoryId: this.state.categoryId,
            tags: this.state.tags,
            approved: this.state.approvalMode
        };

        const { response } = await Api.post("/api/approveTransaction", updateItem);

        if (response.success) {
            this.setState({ editLabel: "ערוך", editMode: false });
            this.state.showSaveSuccess();
            this.state.removeTransactionCallback(this.state.id);
        } else {
            this.state.showSaveError();
        }
        this.setState({ saveInProcess: false });
    }

    async handleKnownTransactionClick() {
        const updateItem = {
            description: this.state.description
        };

        const { response } = await Api.post("/api/setKnownTransaction", updateItem);

        if (response.success) {
            this.state.showSaveSuccess();
            this.state.removeTransactionCallback(this.state.id);
        } else {
            this.state.showSaveError();
        }
    }

    async handleDeleteClick() {
        try {
            const response = await Api.deleteTransaction(this.state.id, this.state.type);
            if (response.status === 200) {
                this.state.showSaveSuccess();
                this.state.removeTransactionCallback(this.state.id);
            } else {
                this.state.showSaveError();
            }
        } catch (error) {
            console.log(`Error deleting Item ${this.state.id} of type ${this.state.type}`, error);
            this.state.showSaveError();
        }
    }

    editClick = () => {
        if (this.state.editLabel === "סגור") {
            this.setState({ editLabel: "ערוך", editMode: false });
        } else {
            this.setState({ editLabel: "סגור", editMode: true });
        }
    };

    handleCategoryChanged = (selectedCategoryId) => {
        this.setState({
            categoryId: selectedCategoryId,
            categoryDescription: this.getCategoryDescription(selectedCategoryId)
        });
    };

    handleTagChanged = (selectedTagIds) => {
        this.setState({ tags: selectedTagIds });
    };

    getTransactionSummary = function () {
        const summary =
            "** בירור עסקה ** " +
            "\n" +
            "תאריך: " +
            this.state.time +
            "\n" +
            "תיאור: " +
            this.state.description +
            "\n" +
            "מחיר: " +
            this.state.amount +
            "\n" +
            "קוגוריה מוצעת: " +
            this.state.categoryDescription;

        const encodedSummary = encodeURI(summary);
        return encodedSummary;
    };

    handleRemarksChange(event) {
        this.setState({ remarks: event.target.value });
    }

    handleTouchStart = (e) => {
        if (this.props.selectionMode) return;
        
        // Store touch position
        this.touchStartPos = {
            x: e.touches[0].clientX,
            y: e.touches[0].clientY
        };
        
        this.longPressTimer = setTimeout(() => {
            // Vibrate if available
            if (navigator.vibrate) {
                navigator.vibrate(50);
            }
            if (this.props.onLongPress) {
                this.props.onLongPress(this.state.id);
            }
        }, 500);
    }

    handleTouchMove = (e) => {
        // Cancel long press if finger moves too much
        if (this.touchStartPos && this.longPressTimer) {
            const moveX = Math.abs(e.touches[0].clientX - this.touchStartPos.x);
            const moveY = Math.abs(e.touches[0].clientY - this.touchStartPos.y);
            
            if (moveX > 10 || moveY > 10) {
                clearTimeout(this.longPressTimer);
                this.longPressTimer = null;
            }
        }
    }

    handleTouchEnd = () => {
        if (this.longPressTimer) {
            clearTimeout(this.longPressTimer);
            this.longPressTimer = null;
        }
        this.touchStartPos = null;
    }

    handleSelectionToggle = (e) => {
        e.stopPropagation();
        if (this.props.onSelectionChange) {
            this.props.onSelectionChange(this.state.id, !this.props.isSelected);
        }
    }

    componentWillUnmount() {
        if (this.longPressTimer) {
            clearTimeout(this.longPressTimer);
        }
    }

    render() {
        const sendWhatsappSummary = `whatsapp://send?text=${this.getTransactionSummary()}`;
        const searchLink = `https://www.google.co.il/search?q=${this.state.description}`;

        const categoryComponent = (
            <h4 style={{ marginTop: "2px", marginBottom: "0", fontSize: "14px", color: "#555", fontWeight: "500" }}>{this.state.categoryDescription}</h4>
        );
        const amountColor = this.state.isCredit ? "#23d188" : "#ed578b";
        // const amountRow = this.state.totalAmount ? `(${this.state.totalAmount}) ${this.state.amount}₪` : `${this.state.amount}₪`;
        const amountRow = `${this.state.amount}₪`;
        const transactionIcon = this.state.type === "Account" ? bankIcon : creditCardIcon;

        const isSelected = this.props.isSelected || false;
        const selectionMode = this.props.selectionMode || false;

        return (
            <div
                onTouchStart={this.handleTouchStart}
                onTouchMove={this.handleTouchMove}
                onTouchEnd={this.handleTouchEnd}
                onClick={selectionMode ? this.handleSelectionToggle : undefined}
                style={{
                    borderRadius: "6px",
                    borderWidth: "1px",
                    direction: "rtl",
                    minHeight: "65px",
                    alignItems: "center",
                    backgroundColor: isSelected ? "#E3F2FD" : "white",
                    margin: "2px 12px",
                    padding: "10px 12px",
                    border: isSelected ? "2px solid #2196F3" : "none",
                    borderBottom: isSelected ? "2px solid #2196F3" : "1px solid #f0f0f0",
                    position: "relative",
                    transition: "all 0.2s ease",
                    cursor: selectionMode ? "pointer" : "default",
                    WebkitUserSelect: "none",
                    userSelect: "none",
                    WebkitTouchCallout: "none"
                }}
            >
                {/* Selection Checkbox - Only visible in selection mode */}
                {selectionMode && (
                    <div
                        onClick={this.handleSelectionToggle}
                        style={{
                            position: "absolute",
                            top: "10px",
                            left: "10px",
                            width: "28px",
                            height: "28px",
                            borderRadius: "50%",
                            backgroundColor: isSelected ? "#2196F3" : "white",
                            border: isSelected ? "none" : "2px solid #CCC",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            zIndex: 10,
                            transition: "all 0.2s ease",
                            cursor: "pointer",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                        }}
                    >
                        {isSelected && (
                            <span style={{ color: "white", fontSize: "18px", fontWeight: "bold" }}>✓</span>
                        )}
                    </div>
                )}
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        marginTop: "2px",
                        alignItems: "center"
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            marginLeft: "8px",
                            gap: "4px"
                        }}
                    >
                        <img
                            src={transactionIcon}
                            style={{
                                height: 28,
                                width: 28,
                            }}
                            alt={this.state.type === "Account" ? "Bank" : "Credit Card"}
                        />
                        {this.state.reccuringData && !selectionMode &&
                            <div style={{fontSize: "14px"}}>🔁</div>
                        }
                        {!selectionMode && (
                            <CommentButton
                                transactionId={this.state.id.toString()}
                                transactionDescription={this.state.description}
                                transactionAmount={this.state.amount}
                                transactionType={this.state.type}
                                hasComments={this.props.item.hasComments}
                            />
                        )}
                    </div>
                    <div
                        style={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            visibility: selectionMode ? "hidden" : "visible",
                            marginLeft: "4px"
                        }}
                    >
                        {this.state.saveInProcess ? (
                            <div className="loading-spinner"></div>
                        ) : (
                            <BsCheckLg
                                style={{
                                    width: "26px",
                                    height: "26px",
                                    color: "green"
                                }}
                                onClick={this.handleSaveClick.bind(this)}
                            />
                        )}
                        {this.state.editMode ? (
                            <IoIosArrowDown
                                style={{
                                    width: "22px",
                                    height: "22px",
                                    marginTop: "4px"
                                }}
                                onClick={this.editClick.bind(this)}
                            />
                        ) : (
                            <IoIosArrowForward
                                style={{
                                    width: "22px",
                                    height: "22px",
                                    marginTop: "4px"
                                }}
                                onClick={this.editClick.bind(this)}
                            />
                        )}
                    </div>
                    <div style={{ flex: 4 }}>
                        <h4 style={{ margin: "0 0 3px 0", fontSize: "16px", lineHeight: "1.3", fontWeight: "700" }}>
                            {this.state.description}
                        </h4>
                        {categoryComponent}
                    </div>
                    <div
                        style={{
                            flex: 2,
                            alignSelf: "center",
                            textAlign: "left",
                            marginLeft: "12px"
                        }}
                    >
                        <h3
                            style={{
                                color: amountColor,
                                fontWeight: "700",
                                direction: "ltr",
                                margin: "0 0 3px 0",
                                fontSize: "18px"
                            }}
                        >
                            {amountRow}
                        </h3>
                        <h5 style={{ color: "#777", fontWeight: "500", margin: "0", fontSize: "13px" }}>{this.state.time}</h5>
                    </div>
                </div>
                {this.state.editMode ? (
                    <div
                        style={{
                            marginTop: "20px",
                            borderTopStyle: "solid",
                            borderTopWidth: "0.5px",
                            borderTopColor: "lightgray",
                            display: "flex",
                            flexDirection: "row"
                        }}
                    >
                        <div
                            style={{
                                marginTop: "20px",
                                width: "100%",
                                flex: 6
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    marginRight: "20px"
                                }}
                            >
                                <button
                                    onClick={this.handleKnownTransactionClick.bind(this)}
                                >
                                    עסקה מוכרת
                                </button>
                                <button
                                    style={{ marginRight: "15px" }}
                                    onClick={this.handleDeleteClick.bind(this)}
                                >
                                    מחיקה
                                </button>
                            </div>

                            {this.state.creditCard && <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    marginRight: "20px",
                                    marginTop: "10px"
                                }}
                            >
                                <h5 style={{ width: "90px" }}>כ.אשראי</h5>
                                <h6>{this.state.creditCard}</h6>
                            </div>}


                            {this.state.accountNumber && <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    marginRight: "20px",
                                    marginTop: "10px"
                                }}
                            >
                                <h5 style={{ width: "90px" }}>חשבון</h5>
                                <h6>{this.state.accountNumber}</h6>
                            </div>}

                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    marginRight: "20px",
                                }}
                            >
                                <h5 style={{ width: "90px" }}>ציון</h5>
                                <h6>{this.state.predictionGrade}</h6>
                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    marginRight: "20px"
                                }}
                            >
                                <h5 style={{ width: "70px" }}>קטגוריה</h5>
                                <div style={{ width: "200px" }}>
                                    <Select
                                        options={this.state.categoryLookup}
                                        selected={this.state.categoryId}
                                        onSelect={this.handleCategoryChanged}
                                        closeOnSelect={true}
                                        placeholder="קטגוריה"
                                        isSearchable={true}
                                    />
                                </div>
                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    marginRight: "20px",
                                    marginTop: "10px"
                                }}
                            >
                                <h5 style={{ width: "70px" }}>תגיות</h5>
                                <div style={{ width: "200px" }}>
                                    <Select
                                        options={this.state.tagLookup}
                                        selected={this.state.tags}
                                        onSelect={this.handleTagChanged}
                                        multi={true}
                                        placeholder="תגיות"
                                        isSearchable={true}
                                    />
                                </div>
                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    marginRight: "20px",
                                    marginTop: "10px",
                                    marginBottom: "20px"
                                }}
                            >
                                <h5 style={{ width: "70px" }}>הערות</h5>
                                <div>
                                    <input
                                        type="text"
                                        value={this.state.remarks}
                                        onChange={this.handleRemarksChange.bind(this)}
                                        style={{
                                            width: "200px",
                                            height: "40px",
                                            borderWidth: "1px",
                                            marginBottom: "5px"
                                        }}
                                    ></input>
                                </div>
                            </div>
                            {this.props.item.reccuringData && (
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        marginRight: "20px",
                                        marginTop: "10px",
                                        marginBottom: "10px",
                                        backgroundColor: "#f9f9f9",
                                        borderRadius: "6px",
                                        padding: "10px",
                                        border: "1px solid #e0e0e0",
                                        maxWidth: "300px"
                                    }}
                                >

                                    <h5 style={{ fontWeight: "bold", marginBottom: "6px" }}>🔁 פרטי עסקה חוזרת</h5>
                                    <div style={{ display: "flex", flexDirection: "row" }}>
                                        <h6 style={{ width: "80px" }}>שם</h6>
                                        <h6>{this.props.item.reccuringData.name}</h6>
                                    </div>
                                    <div style={{ display: "flex", flexDirection: "row" }}>
                                        <h6 style={{ width: "80px" }}>תיאור</h6>
                                        <h6>{this.props.item.reccuringData.description}</h6>
                                    </div>
                                    <div style={{ display: "flex", flexDirection: "row" }}>
                                        <h6 style={{ width: "80px" }}>קטגוריה</h6>
                                        <h6>{this.getCategoryDescription(this.props.item.reccuringData.categoryId)}</h6>
                                    </div>
                                    <div style={{ display: "flex", flexDirection: "row" }}>
                                        <h6 style={{ width: "80px" }}>סוג</h6>
                                        <h6>{this.props.item.reccuringData.type}</h6>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div style={{ flex: 1 }}>
                            <div style={{ paddingTop: "10%" }}>
                                <a href={sendWhatsappSummary}>
                                    <img src={enquiry_button} style={{ width: "70%", height: "70%" }} />
                                </a>
                            </div>

                            <div style={{ paddingTop: "10%" }}>
                                <a href={searchLink} target="_blank">
                                    <img src={search_button} style={{ width: "70%", height: "70%" }} />
                                </a>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div />
                )}
            </div>
        );
    }
}

export default MobileTransactionItem;
